import { connect } from "react-redux";
import * as soldLoanActions from "./actions";

function mapStateToProps(state) {
  return {
    soldLoans: state.soldLoans,
    dca: state.soldLoans.dca,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSoldCandidatesLoans: () => {
      dispatch(soldLoanActions.get_sold_candidates_loans());
    },

    sellLoan: (creditId, creditSoldDate, soldAmount, paymentId, OCR) => {
      dispatch(
        soldLoanActions.sell_loan(
          creditId,
          creditSoldDate,
          soldAmount,
          paymentId,
          OCR,
        ),
      );
    },

    sellLoansBulk: (data) => {
      dispatch(soldLoanActions.sell_loans_bulk(data));
    },

    fetchDCAInfo: (ssn, isLsys) => {
      dispatch(soldLoanActions.fetch_dca_info(ssn, isLsys));
    },

    registerDebtCollectionPayment: (
      amount,
      paymentNumber,
      originatorCreditId,
    ) => {
      dispatch(
        soldLoanActions.register_debt_collection_payment(
          String(amount).replace(",", "."),
          paymentNumber,
          originatorCreditId,
        ),
      );
    },

    registerDebtCollectionCreditLoss: (originatorCreditId) => {
      dispatch(
        soldLoanActions.register_debt_collection_credit_loss(
          originatorCreditId,
        ),
      );
    },

    clearDialogData: () => {
      dispatch(soldLoanActions.clear_dialog_data());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps);
